import React from 'react'
import Temp from './components/weather/temp'


const App = () => {
  return (
    <Temp />
  )
}

export default App
